import apiClient from "./api";

export interface Income {
  id?: number;
  ref: string;
  category_id?: number;
  category_code?: string;
  category_name?: string;
  category?: {
    id?: number;
    code?: string;
    name?: string;
  };
  date: string;
  amount: number;
  description?: string;
  status?: number;
  warehouse_id?: number;
  warehouse_code?: string;
  warehouse_name?: string;
  warehouse?: {
    id?: number;
    code?: string;
    name?: string;
  };
  created_at?: string;
  updated_at?: string;
}

export interface IncomeCategory {
  id?: number;
  code: string;
  name: string;
  description?: string;
  status?: number;
  created_at?: string;
  updated_at?: string;
}

const incomeService = {
  async getIncomes(): Promise<Income[]> {
    const response = await apiClient.get("/income");
    return response.data.data ?? response.data;
  },
  async getIncome(id: number): Promise<Income> {
    const response = await apiClient.get(`/income/${id}`);
    return response.data.data ?? response.data;
  },
  async createIncome(input: Income): Promise<Income> {
    const response = await apiClient.post("/income", input);
    return response.data.data ?? response.data;
  },
  async updateIncome(id: number, input: Partial<Income>): Promise<Income> {
    const response = await apiClient.put(`/income/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteIncome(id: number): Promise<void> {
    await apiClient.delete(`/income/${id}`);
  },
  async getNextReference(): Promise<string> {
    const response = await apiClient.get("/income/next-reference");
    return response.data.data ?? response.data;
  },
  async getIncomeCategories(): Promise<IncomeCategory[]> {
    const response = await apiClient.get("/income-categories");
    return response.data.data ?? response.data;
  },
  async createIncomeCategory(input: IncomeCategory): Promise<IncomeCategory> {
    const response = await apiClient.post("/income-categories", input);
    return response.data.data ?? response.data;
  },
  async updateIncomeCategory(id: number, input: Partial<IncomeCategory>): Promise<IncomeCategory> {
    const response = await apiClient.put(`/income-categories/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteIncomeCategory(id: number): Promise<void> {
    await apiClient.delete(`/income-categories/${id}`);
  },
};

export default incomeService;
